import { render } from "./CompanyAccount-TwoTreesCallLogs.vue?vue&type=template&id=6d4bfb60&scoped=true"
import script from "./CompanyAccount-TwoTreesCallLogs.vue?vue&type=script&lang=js"
export * from "./CompanyAccount-TwoTreesCallLogs.vue?vue&type=script&lang=js"

import "./CompanyAccount-TwoTreesCallLogs.vue?vue&type=style&index=0&id=6d4bfb60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4bfb60"]])

export default __exports__